
  import { Vue, Component, Prop } from "vue-property-decorator";
  import PencilIcon from "@/components/icons/PencilIcon.vue";
  import ProjectDocumentAccessScopeModal from "@/components/documents/ProjectDocumentAccessScopeModal.vue";

  @Component({
    components: {
      ProjectDocumentAccessScopeModal,
      PencilIcon
    },
  })
  export default class ProjectDocumentAccessScope extends Vue {
    @Prop({ type: String, required: true }) readonly documentId!: string;
    @Prop({ type: String, required: true }) readonly fileName!: string;
    @Prop({ type: String, required: true }) readonly documentExtension!: string;
    @Prop({ type: String, required: true }) readonly projectId!: string;

    modalShown: boolean = false;

    onAccessScopeUpdate(): void {
      this.hideModal();
      this.$emit("accessScopeUpdated");
    }

    hideModal(): void {
      this.modalShown = false;
    }
  }
